export default class TokenExpiredError extends Error {
  constructor() {
    super('Der Abruftoken der Befehlsnachricht ist abgelaufen.')
    this.name = 'TokenExpiredError'
    Object.setPrototypeOf(this, TokenExpiredError.prototype)
  }
}
